<template>
  <v-row>
    <template v-if="station && !station.data.error">
      <v-col cols="12" md="4">
        <LMap
          v-if="station"
          :center="[station.latitude, station.longitude]"
          :zoom="7"
          ref="map"
          style="height: 100%"
        >
          <LTileLayer :url="url" />
          <LMarker
            v-if="station"
            :lat-lng="[station.latitude, station.longitude]"
          >
            <LIcon>
              <v-btn x-small fab color="white"
                ><v-icon x-small color="primary">mdi-wifi</v-icon></v-btn
              >
            </LIcon>
          </LMarker>
          <LControl position="topright" v-if="station"> </LControl>
        </LMap>
      </v-col>
      <v-col cols="12" md="8">
        <v-card elevation="0" color="grey lighten-5" class="card-outter">
          <v-card-title>
            <h1>{{ station.libelle_station }}</h1>
            <v-spacer></v-spacer>
            <v-switch
              v-model="state"
              :loading="loading"
              @change="changeState()"
            />
          </v-card-title>
          <v-card-text v-if="station.valide">
            <v-row v-if="station.data.length">
              <v-col cols="12" v-if="station.valide"
                ><h1 class="display-1 font-weight-bold">
                  <template v-if="station.data[station.data.length - 1].temp != null">
                  {{ Math.round(station.data[station.data.length - 1].temp * 10) / 10 }} °C
                  </template>
                  <template v-else>-</template>
                </h1></v-col
              >

              <v-col cols="12" md="4">
                <v-alert border="left" colored-border color="red lighten-3">
                  <h3 class="red--text lighten-4">
                    {{ $t("stations.data.infos.tempTitle") }}
                  </h3>
                  {{ $t("stations.data.infos.tempShort") }}
                  <b>
                  <template v-if="station.data[station.data.length - 1].temp != null">
                    {{ Math.round(station.data[station.data.length - 1].temp * 100) / 100 }} °C
                  </template>
                  <template v-else>
                    -
                  </template>
                  </b><br />
                  <span  v-if="$env.VUE_APP_WHITE_MARK_ID != 'monithermo'">
                  {{ $t("stations.data.infos.dewPoint") }}:
                    <template v-if="(station.data[station.data.length - 1].dewpt != null)">
                  <b>{{ Math.round(station.data[station.data.length - 1].dewpt * 100) / 100 }} °C</b>
                    </template>
                    <template v-else>-</template>
                  <br />
                  <br />
                  </span>
                  <span  v-if="$env.VUE_APP_WHITE_MARK_ID == 'monithermo'">
                    {{ $t("stations.data.infos.humidityShort") }}
                    
                    <b>
                      <template v-if="station.data[station.data.length - 1].rh != null">
                      {{ Math.round(station.data[station.data.length - 1].rh) }} %
                      </template>
                      <template v-else>-</template>
                      </b><br />
                  </span>
                </v-alert>
              </v-col>
              <v-col cols="12" md="4"  v-if="$env.VUE_APP_WHITE_MARK_ID != 'monithermo'">
                <v-alert border="left" colored-border color="primary lighten-4">
                  <h3 class="primary--text lighten-4">
                    {{ $t("stations.data.infos.windTitle") }}
                  </h3>
                  {{ $t("stations.data.infos.averageWind") }}:
                  <b>
                    <template v-if="station.data[station.data.length - 1].wind != null">
                    {{ Math.round(station.data[station.data.length - 1].wind * 3.6) }} km/h
                    </template>
                    <template v-else>-</template>
                    
                    </b><br />
                  {{ $t("stations.data.infos.gusts") }}:
                  <b>
                    <template v-if="station.data[station.data.length - 1].gust != null">
                    {{ Math.round(station.data[station.data.length - 1].gust * 3.6) }} km/h
                    </template>
                    <template v-else>-</template>
                    </b>
                  <br />
                  <br />
                </v-alert>
              </v-col>
              <v-col cols="12" md="4"  v-if="$env.VUE_APP_WHITE_MARK_ID != 'monithermo'">
                <v-alert border="left" colored-border color="purple lighten-4">
                  <h3 class="purple--text lighten-4">
                    {{ $t("stations.data.infos.rainTitle") }}
                  </h3>
                  {{ $t("stations.data.infos.pressureShort") }}
                  <b>
                    <template v-if="station.data[station.data.length - 1].pressure != null"> {{ Math.round(station.data[station.data.length - 1].pressure) }} hPa</template>
                    <template v-else>
                      -
                    </template>
                   
                    
                    </b><br />
                  {{ $t("stations.data.infos.precipShort") }}
                  <b
                    >
                    <template v-if="station.data[station.data.length - 1].rain != null">
                    {{ Math.round(station.data[station.data.length - 1].rain) }} mm
                    </template>
                    <template v-else>-</template>
                    {{ $t("stations.data.infos.fiveMinutes") }}</b
                  ><br />

                  {{ $t("stations.data.infos.humidityShort") }}
                  
                  <b>
                    <template v-if="station.data[station.data.length - 1].rh != null">
                    {{ Math.round(station.data[station.data.length - 1].rh) }} %
                    </template>
                    <template v-else>-</template>
                    </b><br />
                </v-alert>
              </v-col>
              <v-col>
                <v-dialog max-width="80vw" v-model="openStationData">
                  <v-card class="mx-auto">
                    <v-card-title>{{
                      $t("stations.data.infos.stationSettings")
                    }}</v-card-title>
                    <v-card-text>
                      <v-simple-table height="30vh">
                        <tbody>
                          <template
                            v-for="(param, b) in Object.entries(station)"
                          >
                            <tr v-if="!exclude_params.includes(param[0])" :key="b">
                              <td>{{ param[0] }}</td>
                              <td>
                                <v-text-field
                                  disabled
                                  :value="param[1]"
                                ></v-text-field>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </v-simple-table>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
            <template v-else>
              <h3>{{ $t("stations.data.infos.noData") }}</h3>
            </template>
          </v-card-text>
          <v-card-actions class="card-actions" v-if="station.data.length"
            >
            {{ moment((moment.utc(station.data[station.data.length - 1].date).unix()) * 1000).format('ddd DD MMM YYYY HH:mm') }} 
            <v-spacer />
            <v-btn
              elevation="0"
              @click="openStationData = !openStationData"
              small
              ><v-icon small>mdi-information</v-icon></v-btn
            ></v-card-actions
          >
        </v-card>
      </v-col>

      <v-col v-if="station.valide">
        <v-card elevation="0" color="grey lighten-5">
          <v-card-title> {{ $t("stations.data.forecasts") }} </v-card-title>
          <v-card-text>
            <Forecast
              :lat-lng="[station.latitude, station.longitude]"
              :station_data="station.data"
              :geoname="3000"
            />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col v-else cols="12">
        <v-card elevation="0" color="grey lighten-5">
          <v-card-text class="">
            <v-col class="text-center pa-12 my-3">
              <h2 class="my-3">{{ $t("error.yourStationIsDisabled") }}</h2>
              <v-btn
                @click="
                  state = true;
                  changeState();
                "
                elevation="0"
                color="success"
                ><v-icon>mdi-power</v-icon> Réactiver votre station</v-btn
              >
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card elevation="0" color="grey lighten-5">
          <v-card-title>
            {{ $t("stations.data.dataTitle") }} <v-spacer />
            <v-text-field class="mx-3" type="datetime-local" v-model="from" />
            <v-text-field type="datetime-local" v-model="to" class="mx-3" />

            <v-btn
              elevation="0"
              color="success"
              class="mr-3"
              :loading="loading"
              @click="getStation()"
              ><v-icon>mdi-chevron-right</v-icon></v-btn
            >

            <v-btn
              :href="
                api.stations.getExportUrl($route.params.id_station, from, to)
              "
              elevation="0"
              color="info"
              ><v-icon>mdi-file</v-icon></v-btn
            ></v-card-title
          >
          <v-card-text>
            <v-simple-table fixed-header height="20vh">
              <thead>
                <tr>
                  <th>{{ $t("stations.data.date") }}</th>
                  <th >{{ $t("stations.data.tempShort") }}</th>
                  <th v-if="$env.VUE_APP_WHITE_MARK_ID != 'monithermo'">{{ $t("stations.data.wind") }}</th>
                  <th v-if="$env.VUE_APP_WHITE_MARK_ID != 'monithermo'">{{ $t("stations.data.gusts") }}</th>
                  <th >{{ $t("stations.data.humidityShort") }}</th>
                  <th v-if="$env.VUE_APP_WHITE_MARK_ID != 'monithermo'">{{ $t("stations.data.dewPointShort") }}</th>
                  <th v-if="$env.VUE_APP_WHITE_MARK_ID != 'monithermo'">{{ $t("stations.data.precipShort") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, i) in station.data.slice().reverse()"
                  :key="i"
                >
                  <td>
                    {{ moment(moment.utc(data.date).unix()* 1000).format("Do MMMM YYYY[,] H[h]mm") }}
                  </td>
                  <td>{{ data.temp != null ? Math.round(data.temp * 100) / 100 : '-' }}</td>
                  <td v-if="$env.VUE_APP_WHITE_MARK_ID != 'monithermo'">{{ data.wind != null ? Math.round(data.wind) : '-' }}</td>
                  <td v-if="$env.VUE_APP_WHITE_MARK_ID != 'monithermo'">{{ data.gust != null ? Math.round(data.gust) : '-' }}</td>
                  <td>{{ data.rh != null ? Math.round(data.rh * 100) / 100 : '-' }}</td>
                  <td v-if="$env.VUE_APP_WHITE_MARK_ID != 'monithermo'">{{ data.rh != null ? Math.round(data.dewpt * 100) / 100 : '-' }}</td>
                  <td v-if="$env.VUE_APP_WHITE_MARK_ID != 'monithermo'">{{ data.rain != null ? Math.round(data.rain * 100) / 100 : '-' }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </template>
    <template v-else-if="station.data.error">
      <v-container>
        <v-row justify="center">
          <v-col cols="6">
            <v-card elevation="0" color="grey lighten-5">
              <v-card-title>Erreur</v-card-title>
              <v-card-text>
                Aucune donnée disponible pour cette station
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </v-row>
</template>

<script>
/* eslint-disable */
import {
  LMap,
  LTileLayer,
  LCircleMarker,
  LControl,
  LMarker,
  LIcon,
} from "vue2-leaflet";
import _ from "lodash";
import moment from "moment";
import api from "@/api";
import Forecast from "./Forecast.vue";

moment.locale("fr");

export default {
  components: {
    LMap,
    LTileLayer,
    LCircleMarker,
    LControl,
    LIcon,
    LMarker,
    Forecast,
  },
  data: () => ({
    url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
    station: null,
    state: false,
    moment:moment,
    openStationData: false,
    exclude_params:['monitoring', 'sigfox', 'sodaq', 'id_user', 'data', 'id_mode_transfert'],
    from: null,
    to: null,
    moment:moment,
    api: api,
    loading: false,
  }),
  methods: {
    async changeState() {
      this.loading = true;
      try {
        if (this.state) {
          await api.stations.activate(this.station.id_station);
        } else {
          await api.stations.disable(this.station.id_station);
        }
        await this.getStation();
      } catch (err) {
        console.log(err);
      }
      this.loading = false;
    },
    async getStation() {
      this.loading = true;
      try{
        let station = await api.stations.getOne(
          this.$route.params.id_station,
          this.from,
          this.to
        );
        // station.data = _.orderBy(station.data, 'date', 'desc');
        this.state = station.valide;
        this.station = station;
      }catch(err){
        console.log(err);
      }
      this.loading = false;
      // this.$refs.map.mapObject.setView([this.station.latitude, this.station.longitude], 8)
    },
    moment,
  },
  mounted() {
    this.from = moment()
      .subtract(48, "hours")
      .set("minute", 0)
      .format("YYYY-MM-DD[T]HH:mm");
    this.to = moment().set("minute", 0).format("YYYY-MM-DD[T]HH:mm");
    this.getStation();

    // this.getStation();
  },
  watch: {},
};
</script>

<style>
.card-outter {
  position: relative;
  padding-bottom: 50px;
}
.card-actions {
  width: 100%;
  position: absolute;
  bottom: 0;
}
</style>
